import React from 'react';

// Components
import DefaultModal from '@/views/components/modals/DefaultModal';

// Utils
import { formatMessage, FormattedHTMLMessage } from '@/utils/i18n';

const i18nBasePath = 'PortfolioEditorBuilder.InformationReplacedModal';

type Props = {
  onConfirm: () => void;
  onCancel: () => void;
  selectedPlanAccountName: string;
  show: boolean;
};

const InformationReplacedModal = ({ onConfirm, onCancel, show, selectedPlanAccountName }: Props) => {
  const body = (
    <div className="information-replaced-modal-body">
      <div className="main-message">
        <FormattedHTMLMessage id={`${i18nBasePath}.MainMessage`} values={{ name: selectedPlanAccountName }} />
      </div>
      <ul className="info-list">
        <li className="info-item">{formatMessage(`${i18nBasePath}.InfoItems.TotalValue`)}</li>
        <li className="info-item">{formatMessage(`${i18nBasePath}.InfoItems.RiskProfile`)}</li>
      </ul>
      <div className="confirmation-message">{formatMessage(`${i18nBasePath}.ConfirmationMessage`)}</div>
    </div>
  );

  return (
    <DefaultModal
      backdropClassName="modal-v2-backdrop"
      show={show}
      title={formatMessage(`${i18nBasePath}.Title`)}
      body={body}
      onConfirm={onConfirm}
      onCancel={onCancel}
      footerClassName="information-replaced-modal-footer"
    />
  );
};

export default InformationReplacedModal;
